import { asMultiStyleConfig } from '../../../../../utils/theme';
export var ActivityStartItem = asMultiStyleConfig({
  parts: ['container', 'marker', 'timelineContainer', 'contentContainer', 'contentHeading', 'contentSubHeading'],
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'row'
    },
    marker: {
      border: '3px solid',
      borderColor: 'green.500',
      borderRadius: '100%',
      backgroundColor: 'green.500',
      height: '12px',
      width: '12px'
    },
    timelineContainer: {
      flexShrink: 0,
      flexBasis: '1.875rem',
      alignItems: 'center',
      flexDirection: 'column',
      maxWidth: '0.75rem'
    },
    contentContainer: {
      flexDirection: 'column',
      padding: '0rem 0.5rem'
    },
    contentHeading: {
      bottom: '6px',
      fontSize: '1rem',
      fontWeight: 'bold',
      position: 'relative'
    },
    contentSubHeading: {
      fontSize: '0.875rem',
      fontWeight: 'bold'
    }
  }
});